import select from 'dom-select';
import { cl, LazyVideos, setScrollBarVar } from '@/js/utils';
import { bus } from '@/js/bus';
import type Breadcrumbs from "@/js/components/Breadcrumbs";
import type Modal from "@/js/components/Modal";

function sameLinkClick(parent?: HTMLElement) {
  select.all<HTMLAnchorElement>('a', parent).forEach((link) => {
    if (link.origin === window.location.origin && !link.hasAttribute('data-barba-prevent')) {
      link.addEventListener('click', (ev) => {
        if (link.href === window.location.href) {
          ev.preventDefault();
          ev.stopPropagation();
          bus.emit('cancel');
        }
      });
    }
  });
}

function setActiveLinks(parent?: HTMLElement) {
  const pageSegments = new URL(window.location.href).pathname.split('/').filter((f) => !!f);
  const links = select.all<HTMLAnchorElement>('.active-links a', parent);

  cl('.parent-el').remove('active');

  links.forEach((link) => {
    if (link.origin === window.location.origin) {
      const linkSegments = new URL(link.href).pathname.split('/').filter((f) => !!f);
      const last = link.getAttribute('data-last') !== null;
      const parent = link.closest('.parent-el');

      if (
        !link.hash && (
          (pageSegments.length === 0 && linkSegments.length === 0) ||
          (last
            ? pageSegments?.[pageSegments.length - 1] === linkSegments?.[linkSegments.length - 1]
            : linkSegments.length > 0 && linkSegments.every((segment, i) => segment === pageSegments[i]))
        )
      ) {
        cl(link).add('active');
        if (parent) {
          cl(parent as HTMLElement).add('active');
        }
      } else {
        cl(link).remove('active');
      }
    }
  });
}

export function setModalTriggers(parent?: HTMLElement) {
  select.all<HTMLAnchorElement|HTMLButtonElement>('[data-el="modal-trigger"], [href*="#modal:"]', parent).forEach((trigger) => {
    let modalId = trigger.getAttribute('data-modal-id');
    const modalData = trigger.getAttribute('data-modal-data');
    if (trigger.tagName === 'A') {
      const match = trigger.getAttribute('href')?.match(/(?<=#modal:)(.*)?/)?.[0];
      if (match) {
        modalId = match;
      }
    }
    if (modalId) {
      trigger.addEventListener('click', (ev) => {
        ev.preventDefault();
        ev.stopPropagation();
        const modal = select<Modal>(`#${modalId}`);
        if (modal) {
          modal.toggle(modalData ? JSON.parse(modalData) : {});
        }
      })
    }
  })
}

export function globalInit() {
  sameLinkClick();
  setActiveLinks();
  setScrollBarVar();
  setModalTriggers();

  const lazyVideos = new LazyVideos();
  const breadcrumbs = select<Breadcrumbs>('b-breadcrumbs');
  breadcrumbs?.addEventListener('connected', () => {
    breadcrumbs.scrollToActive();
  })

  bus.on('barba_enter', ({ next }) => {
    setActiveLinks();
    sameLinkClick(next.container);
    setModalTriggers(next.container);
    lazyVideos.update(next.container);
    cl('.menu').remove('contacts');
  });

  bus.on('cancel', () => {
    cl('.menu').remove('contacts');
  })

  bus.on('paginate', (container) => {
    lazyVideos.update(container);
  });

  document.addEventListener('onFormieInit', (e) => {
    // @ts-ignore
    // Fetch the Form Factory once it's been loaded
    let Formie = e.detail.formie;

    // @ts-ignore
    // Refresh the necessary bits that are statically cached (CSRF inputs, captchas, etc)
    Formie.refreshForCache(e.detail.formId);
  });
}
